import React, { useEffect, useState } from "react";
import Table from "../../common/Table";
import { useDispatch, useSelector } from "react-redux";
import { AiOutlineDelete } from "react-icons/ai";
import { CgEye } from "react-icons/cg";
import Model from "../../common/Model";
import ConfirmationPage from "../../common/ConfirmationPage";
import { toast } from "react-toastify";
import {
  deleteResultReport,
  getAllResultReport,
} from "../../redux/services/reportSlice";
import { exportToTablePDF } from "../../common/PdfFormat";

const ResultReport = () => {
  const dispatch = useDispatch();
  const getResultReportData = useSelector(
    (state) => state?.report?.resultReport
  );
  const [resultpage, setResultPage] = useState(0);
  const limitOptions = [
    { value: 10, label: 10 },
    { value: 30, label: 30 },
    { value: 50, label: 50 },
    { value: 100, label: 100 },
  ];
  const [pageLimit, setPageLimit] = useState(limitOptions[0]?.value);
  const [resultItemToDelete, setResultItemToDelete] = useState(null);
  const [resultConfirm, setResultConfirm] = useState(false);
  const [modelOpen, setModelOpen] = useState(false);
  const [details, setDetails] = useState(null);
  const getResultReport = React.useCallback(async () => {
    try {
      await dispatch(
        getAllResultReport({ page: resultpage + 1, limit: pageLimit })
      );
    } catch (error) {}
  }, [dispatch, resultpage, pageLimit]);
  useEffect(() => {
    getResultReport();
  }, [getResultReport]);
  const deleteResultData = async () => {
    try {
      const response = await dispatch(deleteResultReport(resultItemToDelete));
      toast.success(response?.message, {
        autoClose: 2000,
        pauseOnHover: false,
      });
      setResultConfirm(false);
      getResultReport();
    } catch (error) {}
  };
  const ResultColumns = [
    {
      label: "S/N",
      key: "index",
      render: (_, __, index) => resultpage * pageLimit + index + 1 || index + 1,
    },
    {
      label: "Name",
      key: "userName",
      render: (_, row) => {
        if (!row?.user) {
          return "-";
        }
        return `${row?.user?.firstName + " " + row?.user?.lastName}`;
      },
    },
    {
      label: "Email",
      key: "email",
      render: (_, row) => row?.user?.email || "-",
    },
    {
      label: "Ph No.",
      key: "contact",
      render: (_, row) =>
        row?.user?.contact?.mobile
          ? `${row?.user?.contact?.countryCode} ${row?.user?.contact?.mobile}`
          : "-",
    },
    {
      label: "Referral Code",
      key: "referral-code",
      render: (_, row) => row?.user?.referralCode || "-",
    },
    {
      label: "Balance",
      key: "balance",
      render: (_, row) => row?.user?.walletBalance || "-",
    },
  ];
  const resultActions = [
    {
      icon: <AiOutlineDelete className="w-6 h-6" />,
      onClick: (row) => {
        setResultItemToDelete(row._id);
        setResultConfirm(true);
      },
    },
    {
      icon: <CgEye className="w-5 h-5" />,
      onClick: (row) => {
        setModelOpen(true);
        setDetails(row);
      },
    },
  ];
  const exportToPDF = () => {
    const headersConfig = ResultColumns;
    const data = getResultReportData?.result_report_data || [];
    exportToTablePDF({
      tableName: "Result Report",
      data,
      headersConfig,
      pdfName: "result_report.pdf",
    });
  };
  return (
    <div>
      <Table
        title="Result Report"
        columns={ResultColumns}
        data={getResultReportData?.result_report_data || []}
        actions={resultActions}
        onPageChange={(selectedItem) => setResultPage(selectedItem.selected)}
        pageCount={getResultReportData?.state?.page_limit}
        pageLimitOptions={limitOptions}
        selectedPageLimit={pageLimit}
        onPageLimitChange={setPageLimit}
        exportButton={true}
        onExport={exportToPDF}
      />
      {resultConfirm && (
        <ConfirmationPage
          topicName="Result Report"
          confirm={resultConfirm}
          onDelete={deleteResultData}
          onCancel={() => setResultConfirm(false)}
        />
      )}
      {modelOpen && (
        <Model closeModal={() => setModelOpen(false)} title="Report Details">
          <div className="space-y-4">
            {details?.user && (
              <h3>
                <span className="font-bold"> Name :</span> 
                {details?.user?.firstName + " " + details?.user?.lastName}
              </h3>
            )}
            {details?.question?.englishQuestion?.question && (
              <h3>
                <span className="font-bold">Question :</span> 
                {details?.question?.englishQuestion?.question
                  ? details?.question?.englishQuestion?.question
                  : "-"}
              </h3>
            )}

            {details?.subject?.name && (
              <h3>
                <span className="font-bold"> Subject :</span> 
                {details?.subject?.name}
              </h3>
            )}
            {details?.message && (
              <h3>
                <span className="font-bold"> Message :</span> {details?.message}
              </h3>
            )}
          </div>
        </Model>
      )}
    </div>
  );
};

export default ResultReport;
